import { Middleware } from "@nuxt/types"

const publicOnly: Middleware = async ({ app, store, redirect, route }) => {
  const hasToken = !!store.state.oauth.accessToken
  const { path } = route

  const verifyResend = app.localePath('account-verify-resend')
  const verifyExpired = app.localePath('account-verify-expired')

  if (path === verifyResend || path === verifyExpired) {
    return
  }

  if (hasToken) {
    return redirect(app.localePath('index'))
  }

  return
}

export default publicOnly
